import React, { useId } from 'react';
import { formControlClass, formLabelClass } from './fieldStyles';

/**
 * Native <select> styled to match Input. Accepts either an `options` array
 * of `{ value, label, disabled? }` or children <option> elements.
 */
export const Select = ({
  label,
  error,
  hint,
  options,
  placeholder,
  className = '',
  id,
  children,
  ...props
}) => {
  const uid = useId().replace(/:/g, '');
  const { id: idFromProps, ...restProps } = props;
  const selectId = id ?? idFromProps ?? (label ? `sel-${uid}` : undefined);

  return (
    <div className="w-full">
      {label && (
        <label htmlFor={selectId} className={formLabelClass}>
          {label}
        </label>
      )}
      <div className="relative">
        <select
          id={selectId}
          className={formControlClass({ error: Boolean(error), className: `pr-10 appearance-none bg-white ${className}`.trim() })}
          aria-invalid={error ? true : undefined}
          {...restProps}
        >
          {placeholder !== undefined && (
            <option value="">{placeholder}</option>
          )}
          {Array.isArray(options)
            ? options.map((opt) => (
                <option key={String(opt.value)} value={opt.value} disabled={opt.disabled}>
                  {opt.label}
                </option>
              ))
            : children}
        </select>
        <svg
          className="pointer-events-none absolute right-3.5 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-400"
          fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true"
        >
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
        </svg>
      </div>
      {error ? (
        <p className="mt-1.5 text-sm text-rose-600" role="alert">{error}</p>
      ) : hint ? (
        <p className="mt-1.5 text-xs text-slate-500">{hint}</p>
      ) : null}
    </div>
  );
};

export default Select;
